var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"width":_vm.width,"icon":_vm.icon,"border":"left","color":_vm.color,"text":""}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }